<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label">
                <span>所属分类：</span>
            </div>
            <div class="form-input">
                <Select v-model="formParam.classifyId" filterable clearable>
                    <Option v-for="item in classifyList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加项目</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">详情</Button>
                    <Poptip
                        confirm
                        title="确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            fullscreen
            :closable="false"
            footer-hide>
            <div>
                <new-item v-if="modal" :itemInfo="formItem" @handleClose="handleItemClose"></new-item>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    removeItemInfo, queryItemInfoPage, queryItemClassifyList,
} from "@/api/baseData"

import NewItem from "@/components/BaseData/NewItem"

export default {
    name: "ItemInfo",
    components: {
        NewItem,
    },
    data() {
        return {
            formParam: {
                name: '',
                catalogId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            modal: false,
            loading: false,
            columns: [
                {
                    title: '项目名称',
                    key: 'name',
                    align: 'left',
                    width: 280,
                },
                {
                    title: '项目代码',
                    key: 'code',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '所属分类',
                    key: 'classifyName',
                    align: 'center',
                },
                {
                    title: '项目价格(元)',
                    key: 'totalPrice',
                    align: 'center',
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                },
            ],
            tableData: [],
            classifyList: [],
            formItem: {},
        }
    },
    mounted() {
        queryItemClassifyList({}).then((res) => {
            this.classifyList = res.data
        })
        this.onQuery()
    },
    methods: {
        async onQuery() {
            let res = await queryItemInfoPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        showModal() {
            this.formItem = {}
            this.modal = true
        },
        async edit(row) {
            this.formItem = row
            this.modal = true
        },
        async remove(row) {
            await removeItemInfo(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        handleItemClose(data) {
            if (data) {
                this.onQuery()
            }
            this.modal = false
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}

</style>
